const SERVICE = "payment";

const getPaymentProviderList = async (api) =>
  api.setMethod().get().setService(SERVICE).process("/gatewaylist");

module.exports = {
  getPaymentProviderList,
};
